module.exports = __webpack_public_path__ + "img/oracle-partner-600px.9e1a2466.png";